import React from "react";
import SportsmenImage from "../Common/Components/SportsmenImageNba.jsx";
import Flag from "../Common/Components/Flag.jsx";

const SideTable = ({achievements, details, side}) => {
    let totals = details.reduce((carry, e) => {
        e.details.forEach(detail => {
            carry.sum += detail.points;
            if (!carry[detail.id]) {
                carry[detail.id] = detail.points;
                return;
            }
            carry[detail.id] += detail.points;
        });
        return carry;
    }, {sum: 0});


    return <table className="table table-condensed table-light table-thead-dark table-striped">
        <thead>
        <tr>
            <th/>
            <th><SportsmenImage {...side}/>{side.name}</th>
            <th>Pos.</th>
            {achievements.map(a => <th key={a.id}><abbr title={a.name}>{a.abbr}</abbr></th>)}
            <th>Total</th>
        </tr>
        </thead>
        <tbody>
        {details.map(
            (sportsmen, index) => <SportsmanDetailRow key={sportsmen.id} index={index + 1} {...sportsmen}
                                                      achievements={achievements}/>)}
        <tr>
            <td/>
            <td/>
            <td/>
            {achievements.map(
                a => <td key={a.id}>{totals[a.id] || null}
                </td>)}
            <td>{totals.sum}</td>
        </tr>
        </tbody>
    </table>
};


const SportsmanDetailRow = ({id, countryCode, name, category, details, achievements, index}) => (
    <tr key={id}>
        <td>{index}</td>
        <td><Flag code={countryCode}/>{name}</td>
        <td>{category}</td>
        {achievements.map(
            a => {
                let result = details.find(
                    sportsmenDetail => sportsmenDetail.id == a.id);
                return <AchievementResultFormat key={a.id} result={result}/>
            })}
        <td>{details.reduce((carry, detail) => carry + detail.points, 0)}</td>
    </tr>
);

const AchievementResultFormat = ({result}) => {
    if (!result) {
        return <td/>;
    }
    /**
     * for Played, Win, Draw achievements show points
     */
    if ([1, 2, 3].includes(result.id)) {
        return <td>{result.points}</td>;
    }
    return <td>{`${result.times} (${result.points})`}</td>;
};

export default SideTable;